import { render, staticRenderFns } from "./index.vue?vue&type=template&id=bb4e8900&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {InschrijvingInformatie: require('/data/www/nvpa.org/nvpa/nuxt/components/inschrijving/Informatie.vue').default,InschrijvingStap1: require('/data/www/nvpa.org/nvpa/nuxt/components/inschrijving/stap-1.vue').default,InschrijvingStap2: require('/data/www/nvpa.org/nvpa/nuxt/components/inschrijving/stap-2.vue').default,InschrijvingStap3: require('/data/www/nvpa.org/nvpa/nuxt/components/inschrijving/stap-3.vue').default,InschrijvingStap4: require('/data/www/nvpa.org/nvpa/nuxt/components/inschrijving/stap-4.vue').default,InschrijvingError: require('/data/www/nvpa.org/nvpa/nuxt/components/inschrijving/error.vue').default,InschrijvingSuccess: require('/data/www/nvpa.org/nvpa/nuxt/components/inschrijving/success.vue').default})
